import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Hero from "@/components/landing/Hero";
import Chapters from "@/components/landing/Chapters";
import Marquee from "@/components/landing/Marquee";
import Amser from "@/components/landing/Amser";
import PathChallenges from "@/components/landing/PathChallenges";
import CommunityBlock from "@/components/landing/CommunityBlock";
import Proof from "@/components/landing/Proof";
import FinalCta from "@/components/landing/FinalCta";

export default function Landing() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => setSettings(data))
      .catch(() => setSettings({}));
  }, []);

  return (
    <main data-testid="landing-page">
      <Hero settings={settings} />
      <Chapters />
      <Marquee />
      <Amser />
      <PathChallenges />
      <CommunityBlock />
      <Proof settings={settings} />
      <FinalCta settings={settings} />
    </main>
  );
}
